import { apiService } from './apiService';
import type { SessionStateData, SessionStateResponse } from '../types/sessionState';

/**
 * GET /api/sessions/:sessionId/state: the call so far, for a watcher joining
 * someone else's session or any client catching up after a reconnect. Any
 * active user of the tenant may read it, bot or standalone session alike
 * (backend `controllers/sessionStateController.js`); apiService sends a fresh
 * Firebase token as `Authorization: Bearer`. Null when the saver has written
 * nothing yet. Rejects with apiService's ApiError (it carries the status).
 */
export const fetchSessionState = async (sessionId: string): Promise<SessionStateData | null> => {
  const payload = (await apiService.get(`/sessions/${encodeURIComponent(sessionId)}/state`)) as unknown as
    | SessionStateResponse
    | null;
  return payload?.exists && payload?.data ? payload.data : null;
};
